// Copyright 2022, Imprivata, Inc.  All rights reserved.

import { useMutation } from '@tanstack/react-query';
import { usePlatform } from '../../context/platform/hooks';
import { apiClient } from '../client';

export const useConsentMutation = () => {
  const { codingContext } = usePlatform();
  return useMutation<{ granted: boolean }, Error, boolean>({
    mutationFn: async (granted: boolean) => {
      return apiClient.post<{ granted: boolean }>('consent', () => ({ granted }), codingContext);
    },
  });
};
